/*
  Kaartgevoel: kantelen en glans volgen de muis.

  Werkt op elk element met data-cf-holo, ook op kaarten die later in de pagina
  komen (de setpagina's laden "de rest van de set" pas bij het uitklappen).
  Daarom hangt alles aan document en niet aan de losse elementen: geen listener
  per kaart, en nieuwe kaarten doen vanzelf mee.

  Bewust niet: een tilt op aanraakschermen. Daar is elke aanraking een scroll
  of een tik naar de productpagina, en een kaart die dan gaat kantelen voelt
  als een haperende pagina.
*/
(function () {
  'use strict';

  var MAX_GRADEN = 11;
  var actief = null;

  var stilstaan = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heeftMuis = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!heeftMuis) return;

  function volg(kaart, x, y) {
    var r = kaart.getBoundingClientRect();
    if (!r.width || !r.height) return;

    var px = Math.min(Math.max((x - r.left) / r.width, 0), 1);
    var py = Math.min(Math.max((y - r.top) / r.height, 0), 1);

    if (!stilstaan) {
      var rx = (0.5 - py) * MAX_GRADEN * 2;
      var ry = (px - 0.5) * MAX_GRADEN * 2;
      kaart.style.transform =
        'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' +
        ry.toFixed(2) + 'deg) scale(1.04)';
    }

    kaart.style.setProperty('--cf-mx', (px * 100).toFixed(1) + '%');
    kaart.style.setProperty('--cf-my', (py * 100).toFixed(1) + '%');
    kaart.style.setProperty('--cf-bx', (20 + px * 60).toFixed(1) + '%');
    kaart.style.setProperty('--cf-by', (20 + py * 60).toFixed(1) + '%');
  }

  function loslaten(kaart) {
    if (!kaart) return;
    kaart.style.transform = '';
  }

  document.addEventListener('mousemove', function (e) {
    var kaart = e.target.closest ? e.target.closest('[data-cf-holo]') : null;

    if (kaart !== actief) {
      loslaten(actief);
      actief = kaart;
    }
    if (kaart) volg(kaart, e.clientX, e.clientY);
  }, { passive: true });

  /* Als de muis het venster verlaat blijft de laatste kaart anders gekanteld staan. */
  document.addEventListener('mouseleave', function () {
    loslaten(actief);
    actief = null;
  });

  /* Bij scrollen met het wiel verschuift de kaart onder de muis vandaan zonder
     dat er een mousemove komt. Dan hoort de kanteling terug naar nul. */
  window.addEventListener('scroll', function () {
    if (actief) { loslaten(actief); actief = null; }
  }, { passive: true });
})();
